import axios from "axios";

export const getGoogleAccounts = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/GoogleAccount/getAccounts")
    .then((res) => res.data);
};

export const getGoogleAccountTypes = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/GoogleAccount/getAccountTypes")
    .then((res) => res.data);
};

export const addGoogleAccount = (newAccount) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/GoogleAccount/addAccount/", newAccount)
    .then((res) => res.data);
};

export const editGoogleAccount = (editedAccount) => {
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/GoogleAccount/editAccount/", editedAccount)
    .then((res) => res.data);
};

export const deleteGoogleAccount = (accountId) => {
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/GoogleAccount/deleteAccount/" + accountId)
    .then((res) => res.data);
};
